export default class LibraryCatalog {

    constructor() {
        this.catalogId = 0;
        this.title = '';
        this.subtitle = '';
        // LibraryCatalogType (PDF, INTERACTIVE, FOLDER, INTELLIGENT_FOLDER, VIDEO, WEB)
        this.catalogType = '';
        this.catalogVideoType = '';
        this.catalogWebType = '';
        this.url = '';
        // URL relativa
        this.path = '';
        // En el caso de que sea una publicación del tipo FOLDER aquí estarían los catálogos hijo
        this.childList = [];
        this.fullscreen = false;
        this.horizontalImage = '';
        this.verticalImage = '';
        this.deviceLanguage = [];
        this.deviceType = [];
        this.publishDate = '';
        this.useAsRoot = false;

        this.horizontalBanner = [];
        this.verticalBanner = [];
        this.bannerInterval = 0;

        this.showExitButton = false;
        this.showIndexButton = false;
        this.showPageSlider = false;
        this.showBookmarksButton = false;
        this.showCatalogMenu = false;
        this.showShareButton = false;

        this.changePageMode = '';

        this.intelligentFolderUrl = '';

        this._parent = undefined;
    }

    getRecursiveChildList() {
        let res = [];
        res = res.concat(this.childList);
        this.childList.forEach((elem) => {
            res = res.concat(elem.getRecursiveChildList());
        });
        return res;
    }

}